export function formatItemToString(itm: any) {
  if (typeof itm !== 'string') {
    return itm.toString();
  }
  return itm;
}
